export default {
  container: {
    gap: 'none',
    margin: {
      vertical: 'xsmall'
    }
  }
}
